
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'StagingOfDiaNep',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Urology/StagingOfDiaNep.vue